import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import useScreenSize from '../../utils/useScreenSize';
import { BillingAddressField } from './billingAddressFields';
import SettingItem from '../SettingItem';
import { borderRadius, palette, spaces } from '../../assets/styles/themes/tokens';

interface BillingAddressViewProps {
  fields: BillingAddressField[];
}

const BillingAddressView = ({ fields }: BillingAddressViewProps) => {
  const { t } = useTranslation();
  const { isXsScreen, isSmScreen } = useScreenSize();
  const isSmallScreen = isXsScreen || isSmScreen;
  const EMPTY_VALUE = 'Not specified';

  return (
    <Box
      sx={{
        borderRadius: borderRadius.lg,
        border: `1px solid ${palette.elevation.outlined}`,
        p: spaces.md,
        backgroundColor: palette.background.paperElevation2,
        display: 'grid',
        gridTemplateColumns: isSmallScreen ? '1fr' : '1fr 1fr',
        gap: spaces.md,
        '& > *:nth-of-type(odd)': {
          padding: 0,
        },
        '& > *:nth-of-type(even)': {
          padding: isSmallScreen ? 0 : `0 0 0 ${spaces.md}`,
        },
      }}
    >
      {fields.map(({ name, label, value }) => (
        <SettingItem
          key={name}
          title={t(label)}
          sx={{ border: 'none' }}
        >
          <Typography>{value || t(EMPTY_VALUE)}</Typography>
        </SettingItem>
      ))}
    </Box>
  );
};

export default BillingAddressView;
